import { render } from "./issue-Details.vue?vue&type=template&id=ff33b32e&scoped=true"
import script from "./issue-Details.vue?vue&type=script&lang=js"
export * from "./issue-Details.vue?vue&type=script&lang=js"

import "./issue-Details.vue?vue&type=style&index=0&id=ff33b32e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ff33b32e"

export default script